import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/theme.css';
import App from './App';
import { AppProvider } from './app-context';
import { loadKillSwitch } from './lib/killswitch';

// Load key display fonts BEFORE first render so the app's first frame is in its
// final typeface (zero font-swap CLS — best-practice §9.x), then drop the boot mask.
// The kill-switch is NOT awaited (its content filter is bundled); the live takedown
// config loads after paint to keep it off the critical render path (better LCP/FCP).
async function boot() {
  const root = document.getElementById('root')!;
  if ('fonts' in document) {
    await Promise.race([
      Promise.all([
        document.fonts.load('400 42px "Bangers"'),
        document.fonts.load('400 28px "Mochiy Pop One"'),
      ]),
      new Promise((r) => setTimeout(r, 2500)),
    ]).catch(() => {});
  }

  root.innerHTML = ''; // clear the crawlable fallback before mounting
  createRoot(root).render(
    <StrictMode>
      <AppProvider>
        <App />
      </AppProvider>
    </StrictMode>,
  );

  const bootEl = document.getElementById('boot');
  if (bootEl) {
    bootEl.classList.add('done');
    setTimeout(() => bootEl.remove(), 350);
  }

  // fetch live takedown config after first paint (non-blocking)
  loadKillSwitch();
}

boot();
